import { defineStore } from 'pinia'
import {
    type GetAnonymousTokenBody,
    GrantType,
    type TokenResponse
} from '~/interfaces/auth'
import useTokenStore from '~/store/token'

const useAuthStore = defineStore('auth', () => {
    async function getAnonymousToken() {
        const tokenStore = useTokenStore()
        const { $throwError } = useNuxtApp()

        const CLIENT_ID = useRuntimeConfig().CLIENT_ID as string
        const CLIENT_SECRET = useRuntimeConfig().CLIENT_SECRET as string
        let payload: GetAnonymousTokenBody = {
            client_id: CLIENT_ID,
            client_secret: CLIENT_SECRET,
            grant_type: GrantType.CLIENT_CREDENTIALS
        }

        if (tokenStore.refreshToken) {
            payload = {
                ...payload,
                refresh_token: tokenStore.refreshToken,
                grant_type: GrantType.REFRESH_TOKEN
            }
        }
        try {
            const data: TokenResponse = await $fetch(
                `${useRuntimeConfig().public.APPLICATION_URL}/community-authentication/token`,
                {
                    method: 'POST',
                    body: payload
                }
            )
            tokenStore.token = data.oauth2_access_token
            tokenStore.refreshToken = data.oauth2_refresh_token
            tokenStore.tokenExpirationDate = data.date_expired
            tokenStore.refreshTokenExpirationDate = data.refresh_date_expired
        } catch (e: any) {
            tokenStore.token = ''
            tokenStore.refreshToken = ''
            tokenStore.tokenExpirationDate = ''
            tokenStore.refreshTokenExpirationDate = ''

            if (e.status !== 404) {
                $throwError(e, 'GetAnonymousToken')
            }

            showError({
                statusCode: e.status || 500,
                statusMessage: 'GetAnonymousToken'
            })
        }
    }

    return {
        getAnonymousToken
    }
})

type AuthStore = Omit<
    ReturnType<typeof useAuthStore>,
    keyof ReturnType<typeof defineStore>
>

export default useAuthStore

export type { AuthStore }
